<template>
  <v-dialog scrollable v-model="model" persistent max-width="600px">
    <material-card
      v-if="bankAccount !== null && bankAccount !== undefined"
      :title="
        $t('components.employers.employer_details.view_deposit_account')
      "
      :color="$vuetify.theme.themes.light.secondary"
      icon="business"
    >
      <v-card-text>
        <div class="row no-gutters">
          <div class="col-12 col-md-4">
            {{ $t("headers.members_management.Institution Number") }}
            <br />
            <span class="minfo">
              {{ bankAccount.InstitutionNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4">
            {{ $t("headers.members_management.Account Number") }}
            <br />
            <span class="minfo">
              {{ bankAccount.AccountNumber }}
            </span>
          </div>
          <div class="col-12 col-md-4">
            {{ $t("headers.members_management.Transit Number") }}
            <br />
            <span class="minfo">
              {{ bankAccount.TransitNumber }}
            </span>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="$emit('close')">
          {{ $t("globals.close") }}
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["model"],
  data() {
    return {
      bankAccount: null,
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["planIdentity"]),
  },
  mounted() {
    if (this.planIdentity.TrustFund) {
      this.bankAccount = this.planIdentity.TrustFund.BankAccount;
    }
  },
};
</script>
<style scoped>
  .minfo {
    font-weight: bold;
    color: #222;
  }
  .member-view /deep/ .v-list-group__items > .v-list-item {
    padding-left: 45px;
  }
  .text-white {
    color: white;
  }
  </style>
